"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateCapiIntegrationRequestToJSON = exports.UpdateCapiIntegrationRequestFromJSONTyped = exports.UpdateCapiIntegrationRequestFromJSON = exports.instanceOfUpdateCapiIntegrationRequest = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the UpdateCapiIntegrationRequest interface.
 */
function instanceOfUpdateCapiIntegrationRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfUpdateCapiIntegrationRequest = instanceOfUpdateCapiIntegrationRequest;
function UpdateCapiIntegrationRequestFromJSON(json) {
    return UpdateCapiIntegrationRequestFromJSONTyped(json, false);
}
exports.UpdateCapiIntegrationRequestFromJSON = UpdateCapiIntegrationRequestFromJSON;
function UpdateCapiIntegrationRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
    };
}
exports.UpdateCapiIntegrationRequestFromJSONTyped = UpdateCapiIntegrationRequestFromJSONTyped;
function UpdateCapiIntegrationRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
    };
}
exports.UpdateCapiIntegrationRequestToJSON = UpdateCapiIntegrationRequestToJSON;
